import { Columns2, Rows2 } from "lucide-react";
import { Input, DefaultTooltip, InputGroup, InputGroupText } from "twyne-new.ui";

import { useCraftProp } from "../utils";

export default function GridTemplateProperty() {
  const { value: rows, setValue: setRows } = useCraftProp('grid.rows')
  const { value: columns, setValue: setColumns } = useCraftProp('grid.columns')

  return <>
    <div className='flex items-center justify-between gap-1'>
      <InputGroup>
        <DefaultTooltip content='Number of rows'>
          <InputGroupText>
            <Rows2 size={14} />
          </InputGroupText>
        </DefaultTooltip>
        <Input
          value={rows || ''}
          onChange={e => setRows(Number(e.target.value))}
          type="number"
          variant='accent'
        />
      </InputGroup>

      <InputGroup>
        <DefaultTooltip content='Number of columns'>
          <InputGroupText>
            <Columns2 size={14} />
          </InputGroupText>
        </DefaultTooltip>
        <Input
          value={columns || ''}
          onChange={e => setColumns(Number(e.target.value))}
          type="number"
          variant='accent'
        />
      </InputGroup>
    </div>
  </>
}
